// This file is ignored by prettier intentionally;
// 'Content-Type': 'application/json', these headers needs to be in single quotes to work, if by any formatter it changes it to double quotes it may create issues in few endpoints, like one or two

import { useMutation, useQuery, useQueryClient } from "react-query";
import { BASE_URL } from "./BaseUrl";

const BASE = BASE_URL;

// get all
export const useGetFetch = ({ key, url, isPage, filters, token }) => {
  let endPoint;

  if (isPage) {
    endPoint = `${url}?page=${isPage}`;
  } else if (!filters) {
    endPoint = `${url}`;
  } else {
    endPoint = `${url}?`;
  }

  if (filters) {
    for (const key in filters) {
      if (key && filters[key]) {
        endPoint += `&${key}=${filters[key]}`;
      }
    }
  }

  const get = async () => {
    const response = await fetch(`${BASE}${endPoint}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.json();
  };

  return useQuery(key, get, {
    staleTime: Infinity,
    retryDelay: Infinity,
    // cacheTime: 0,
  });
};

// get one
export const useFetchById = ({ key, url, userId, token }) => {
  const fetchById = async () => {
    const response = await fetch(`${BASE}${url}/${userId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.json();
  };

  return useQuery(key, fetchById, {
    staleTime: Infinity,
    retryDelay: Infinity,
  });
};

// create
export const useCreateFetch = ({ key, url, token }) => {
  const queryClient = useQueryClient();

  const createUser = async (data) => {
    // console.log("daaata", data);

    const response = await fetch(`${BASE}${url}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    return response.json();
  };

  const mutation = useMutation(createUser, {
    onSuccess: () => {
      queryClient.invalidateQueries(key);
    },
  });

  return mutation;
};

export const useCreateForm = ({ key, url, token }) => {
  const queryClient = useQueryClient();

  const createUser = async ({ data }) => {
    const response = await fetch(`${BASE}${url}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });

    return response.json();
  };

  const mutation = useMutation(createUser, {
    onSuccess: () => {
      queryClient.invalidateQueries(key);
    },
  });

  return mutation;
};

// update one
export const useUpdateFetch = ({ key, url, token }) => {
  const queryClient = useQueryClient();

  const update = async ({ data, uid }) => {
    console.log("data==>", data);

    const response = await fetch(`${BASE}${url}${uid ? uid : ""}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    return response.json();
  };

  const mutation = useMutation(update, {
    onSuccess: () => {
      queryClient.invalidateQueries(key);
    },
  });

  return mutation;
};

export const useUpdateForm = ({ key, url, token }) => {
  const queryClient = useQueryClient();

  const update = async ({ data }) => {
    const response = await fetch(`${BASE}${url}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });
    return response.json();
  };
  const mutation = useMutation(update, {
    onSuccess: () => {
      queryClient.invalidateQueries(key);
    },
  });

  return mutation;
};

export const useUpdateFormJSON = ({ key, url, token }) => {
  const queryClient = useQueryClient();

  const update = async ({ data }) => {
    const response = await fetch(`${BASE}${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json", // single quotes are required
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    return response.json();
  };
  const mutation = useMutation(update, {
    onSuccess: () => {
      queryClient.invalidateQueries(key);
    },
  });

  return mutation;
};

// delete a user
export const useDeleteFetch = ({ key, url, token }) => {
  const queryClient = useQueryClient();

  const deleteUser = async ({ userId, body }) => {
    const response = await fetch(
      `${BASE}${url}/${userId ? `?uid=${userId}` : ""}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: body ? JSON.stringify(body) : null,
      }
    );

    if (!response.ok) {
      throw new Error("Failed to delete");
    }

    return response.json();
  };

  const mutation = useMutation(deleteUser, {
    onSuccess: () => {
      queryClient.invalidateQueries(key);
    },
  });

  return mutation;
};

export const useGetFetchNew = ({ key, url, filters, token }) => {
  let urlNew = "";

  if (filters) {
    const queryParams = Object.entries(filters)
      .filter(([key, value]) => key && value != null && value !== "")
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    if (queryParams) {
      urlNew += `${url.includes("?") ? "&" : "?"}${queryParams}`;
    }
  }

  const get = async () => {
    const response = await fetch(`${BASE}${url}${urlNew}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.json();
  };

  return useQuery(key, get, {
    staleTime: Infinity,
    retry: false,
  });
};
